<template>
<div class="chapter">
<div class="inner_page">
<p class="paraspaceabove"><a id="ch00_fm04"></a><a id="page_iv"></a><span class="small">NEW YORK UNIVERSITY PRESS</span><br/>New York and London<br/>www.nyupress.org</p>
<p class="paraspaceabove">© 2007 by New York University<br/>All rights reserved</p>
<p class="paraspaceabove">Library of Congress Cataloging-in-Publication Data<br/>Dallam, Marie W.<br/>Daddy Grace : a celebrity preacher and his house of prayer/<br/>Marie W. Dallam.<br/>p. cm.<br/>Includes bibliographical references and index.<br/>ISBN-13: 978-0-8147-2010-3 (cloth : alk. paper)<br/>ISBN-10: 0-8147-2010-2 (cloth : alk. paper)<br/>1. United House of Prayer for All People. 2. Grace, Daddy,<br/>1882?–1960. I. Title.<br/>BX8777.6.A4D35 2007<br/>289.9’4—dc22 2007023496</p>
<p class="paraspaceabove">New York University Press books are printed on acid-free paper, and their binding materials are chosen for strength and durability.</p>
<p class="paraspaceabove">Manufactured in the United States of America<br/>10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04.vue?4cac1e5f